
import React from 'react';
import OptimizedHero from './hero/OptimizedHero';

const Hero = () => {
  return <OptimizedHero />;
};

export default Hero;
